import { useStyletron } from 'baseui'

const useDashboardStyles = () => {
  const [css] = useStyletron()
  const paginationStyle = css({
    margin: '1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'auto',
    backgroundColor: 'rgba( 255, 255, 255, 0.5 )',
  })

  return {
    paginationStyle,
  }
}

export default useDashboardStyles
